import React, { memo, useMemo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, Typography, CircularProgress, Divider } from 'investira.react.components';
import { IndicadorTemplate } from '../../../../components/templates';
import { SearchGlobal } from '../../../../components/organisms';
import { getIndicadorDisplayMode } from '../../../../components/organisms/indicadorDisplayMode';
import withCenarios from '../../../../hoc/withCenarios';
import { useIndicadoresContext } from '../../../../contexts/IndicadoresContext';
import IndicadoresCotacao from './IndicadoresCotacao';
import IndicadoresTabular from './IndicadoresTabular';
import IndicadorHeader from '../IndicadorHeader';
const IndicadorOverview = memo(props => {
  const { state } = useIndicadoresContext();
  const { dataInicio, dataFim, indicador, isPageLoading, isIndicadorLoading } = state;
  const xCurrent = indicador.current;
  const xHistorico = indicador.historico || {};
  const xDisplayMode = useMemo(() => getIndicadorDisplayMode(xCurrent), [xCurrent]);
  const xIndicadorCotacaoData = useMemo(() => {
    return [
      {
        indicador: xCurrent.indicador_id,
        data: xHistorico.full || []
      }
    ];
  }, [xCurrent.indicador_id, xHistorico.full]);
  if (isPageLoading || (validators.isEmpty(xCurrent) && isIndicadorLoading)) {
    return (
      <Stack
        sx={{
          height: '100%'
        }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <CircularProgress />
        </Stack>
      </Stack>
    );
  }
  if (validators.isEmpty(xCurrent)) {
    return (
      <Stack
        sx={{
          height: '100%'
        }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <Typography variant="body2" color="textSecondary">
            Indicador não encontrado
          </Typography>
        </Stack>
      </Stack>
    );
  }
  return (
    <IndicadorTemplate
      title={`${xCurrent.indicador_id || ''} - ${xCurrent.indicador || ''} - Indicador
      `}
      header={<IndicadorHeader compare={false} />}
      description={`Descubra tudo sobre ${xCurrent.indicador || xCurrent.indicador_id}`}
      searchComponent={<SearchGlobal />} // SearchIndicadores
      maxWidth="xl">
      <Stack py={2}>
        <Divider />
      </Stack>

      <Stack gap={4}>
        <IndicadoresCotacao
          indicador={xCurrent.indicador_id}
          cotacoes={xIndicadorCotacaoData}
          cenarios={props.cenarios}
          displayMode={xDisplayMode}
          isLoading={isIndicadorLoading}
        />
        <IndicadoresTabular
          dataInicio={dataInicio}
          dataFim={dataFim}
          indicador={xCurrent}
          cotacoes={xIndicadorCotacaoData}
          displayMode={xDisplayMode}
          isLoading={isIndicadorLoading}
        />
      </Stack>
    </IndicadorTemplate>
  );
});
IndicadorOverview.displayName = 'IndicadorOverview';
export default withCenarios(IndicadorOverview, {
  readCenariosParams: {
    page: null,
    size: null
  }
});
